import "jquery/dist/jquery.min.js";
import Axios from "axios";
import $ from "jquery";
import EditForm from "@/pages/trailers/edittrailer/edittrailer.vue";
import MarkAsBeingRepaired from "@/pages/vehicles/markasbeingrepaired/markasbeingrepaired.vue";
import VueGallery from "vue-gallery";
import DriverProfilePicture from "@/pages/drivers/driverprofilepicture/driverprofilepicture";
import DriverTag from "@/pages/drivers/drivertag/drivertag";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import { faHourglassEmpty } from "@fortawesome/free-solid-svg-icons";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import VehicleSorn from "@/pages/vehicles/vehiclesorn/vehiclesorn.vue";
import VehicleDocuments from "@/pages/vehicles/vehicledocuments/vehicledocuments.vue";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
import VehicleServiceHistory from "@/pages/vehicles/vehicleservicehistory/vehicleservicehistory.vue";
import VehicleChecks from "@/pages/vehicles/vehiclechecks/vehiclechecks.vue";
import DeleteImage from '@/pages/operations/deleteimage/deleteimage';
import AddNotes from '@/pages/drivers/addnotes/addnotes';
import Notes from '@/pages/drivers/notes/notes';
import Task from "@/pages/task/task";
import VehicleInspectionsHistory from "@/pages/vehicles/vehicleinspactions/vehicleinspactions.vue";
import AuditLogs from '@/pages/auditlog/auditlogdata/auditlogdata.vue';

var moment = require("moment");
export default {
  components: {
    EditForm,
    MarkAsBeingRepaired,
    VueGallery,
    DriverProfilePicture,
    DriverTag,
    UpcomingEvent,
    VehicleSorn,
    VehicleDocuments,
    DocumentPopup,
    VehicleServiceHistory,
    VehicleChecks,
    DeleteImage,
    AddNotes,
    Notes,
    Task,
    VehicleInspectionsHistory,
    AuditLogs
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
    },
    region: function(data){
      return VehicleRegistrationRegion(data);
    }
  },
  data() {
    return {
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      DocumentPopupAction:"Add",
      DocumentPopupCategory:"",
      DocumentPopupSubCategory:"",
      CompanyData:"",
      PopupLoader: false,
      ShowLoader: false,
      submitted: false,
      TrailerId: 0,
      editForm: false,
      SaveData: false,
      fromDate: "",
      toDate: "",
      vrm: "",
      VehicleNotes: "",
      ShowVehicleNotesModel: false,
      ShowVehicleNotesModelHeading: "Notes",
      inspectionFromDate: "",
      inspectionToDate: "",
      inspectionVRM: "",
      ShowViewDetailModel: false,
      VehicleChecks: [],
      NewTrailer: {
        reg_id: "",
        make: "",
        model: "",
        class: "Trailer",
        type: "Curtain Sider",
        capacity: "",
        max_load_weight: "",
        unladen_weight: "",
      },

      Vehicles:[],
      AssginVehicle: { trailer_id: 0, vehicle_id: 0 },
      file: "",
      SearchData: false,
      gindex: 1,
      AccountPermissions:[],
      ShowTrailerAssignVehicle:false,
      ShowTrailerEdit:false,
      ShowTrailerDelete:false,
      ShowTrailerMarkAsBeingRepaired:false,
      ShowUrgentTask:false,
      ShowVehicleChecks:false,
      FleetSubscription:[],
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
      ShowGenerateURL:false,
      InspectionClasses:[],
      DocumentModelSubCategories:[],
      inspectionVRM:"",
      VehicleId: 0,
      ShowTrailerInspections:true,
    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
      );
      this.AccountPermissions = AccountPermissions;

      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Trailers || !AccountPermissions.Trailers.enable || !AccountPermissions.Trailers.view)){
      this.$router.push('/');
    }
    this.ShowGenerateURL = true;

    if (this.AccountPermissions && 
      this.AccountPermissions.Trailers &&
      this.AccountPermissions.Trailers.enable) {
      if ( this.AccountPermissions.Trailers.edit) {
        this.ShowTrailerEdit = true;
      }
      if ( this.AccountPermissions.Trailers.assign_vehicle) {
        this.ShowTrailerAssignVehicle = true;
      }
      if ( this.AccountPermissions.Trailers.delete) {
        this.ShowTrailerDelete = true;
      }
      if ( this.AccountPermissions.Trailers.mark_as_being_repaired) {
        this.ShowTrailerMarkAsBeingRepaired = true;
      }
    }


    if (AccountPermissions && 
      AccountPermissions['Vehicle Checks'] &&
      AccountPermissions['Vehicle Checks']['enable']) {
        this.ShowVehicleChecks = true;
        if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
          this.ShowUrgentTask = true;
        }
    }

    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowTrailerEdit = true;
      this.ShowTrailerAssignVehicle = true;
      this.ShowTrailerDelete = true;
      this.ShowTrailerMarkAsBeingRepaired = true;
      this.ShowUrgentTask = true;
      this.ShowVehicleChecks = true;
    }

    this.CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (this.CompanyData && this.CompanyData.name) {            
      if(window.taskModuleCompanies.includes(this.CompanyData.id)){
      	this.todaysUrgentTaskNew = true
      }
    }  
    this.TrailerId = this.$route.params.TrailerId;

    if(localStorage.getItem("InspectionsClasses")){
      var InsClasses = JSON.parse(localStorage.getItem("InspectionsClasses"));

      InsClasses.forEach((element, index) => {
        let addClass = true;
        if(element.title == "Trailer" ){
            addClass = true;
        }
        if(addClass){
          if(element.title == "Trailer" ){
            element.title = "Trailer" ;
          }
          this.InspectionClasses.push(element.title);
        }
      });
    }

    this.DocumentModelLoadSubCategories();
    setTimeout(() => {
      this.GetTrailerDetail();
    }, 1000);
  },

  methods: {
    DocumentModelLoadSubCategories() {
      Axios.post(Endpoints.Dcoument.SubCategories, {
        token: localStorage.getItem("token"),
        category: 'vehicle',
      }).then((Response) => {
        if (Response?.data?.success == true && Response?.data?.subcategories.length > 0) {
          Response.data.subcategories.forEach((element) => {
            if(element == 'brakes'){
              if(this.NewTrailer.class == 'Trailer'){
                this.DocumentModelSubCategories.push({
                  id: element,
                  title: 'Brakes Record',
                });
              }
            }else if(element == 'PMI'){
              if(this.InspectionClasses.includes(this.NewTrailer.class) &&
              this.NewTrailer.class == 'Trailer'){
                this.DocumentModelSubCategories.push({
                  id: element,
                  title: 'PMI Inspection',
                });
              }
            }else{
              this.DocumentModelSubCategories.push({
                id: element,
                title: element.replace("_", " "),
              });
            }
            
          });
      }

      });
    },
    AddNote(){
      this.$refs.add_notes_section.NewNoteOpen();
    },
    LoadNotesData(){
			this.$refs.notes_section.GetNotesList();
		},
    AddDocument(type = "") {
      var heading = 'PMI';
      if(type == 'brakes'){
        heading = 'Brakes Test';
      }else if(type == 'service'){
        heading = 'Service';
      }
      var category = "vehicle";
      this.NewDocument={};
      this.DocumentPopupCategory = category;
      this.DocumentPopupSubCategory = type;
      this.$refs.popup.loadPopupModal(type,heading);
    },
    LoadProfileData(){
			this.GetTrailerDetail();
		},
    EditDocument(document) {
    	this.$refs.popup.loadEditData(document);
    },
    DeleteDocument(document_id) {
      this.$refs.popup.DeleteDocumentData(document_id);
    },
    LoadProfileData(){
      this.GetTrailerDetail();
    },
    LoadHistory() {
      this.$refs.service_history.GetVehicleServices();
      this.$refs.vehicle_document.GetDocumentList();
      this.$refs.inspection_history.GetVehicleInspectionsList();
    },
    GetTrailerDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Trailer.Get, {
        token: localStorage.getItem("token"),
        trailer_id: this.TrailerId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.NewTrailer = Response.data.trailer;
          this.inspectionVRM = this.NewTrailer.vrm;
        }else{
          this.$router.push("/error-404");
        }
      });
    },
   
    
    GetVehiclesList(){
			var obj={token: localStorage.getItem('token')}
			Axios.post(Endpoints.Trailer.ListForAssign, obj).then((Response) => {
				if (Response?.data?.success) {
					this.Vehicles = Response.data.vehicles
				}
			})
		},
    UnAssignVehicle(vehicle_link_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to UnAssign this Vehicle?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, UnAssign it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Removing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Trailer.UnAssginVehicle, {
              token: localStorage.getItem("token"),
              vehicle_link_id: vehicle_link_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.GetTrailerDetail();
                this.GetVehiclesList();
                this.$swal
                  .fire("Vehicle UnAssigned Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    AssignVehicle(trailer_id) {
      this.AssginVehicle.trailer_id = trailer_id;
      this.AssginVehicle.vehicle_id = 0;
      this.GetVehiclesList();
    },
    SubmitAssignVehicle() {
      this.$swal.fire({
        title: "Assigning...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      if (
        this.AssginVehicle.vehicle_id > 0 &&
        this.AssginVehicle.trailer_id > 0
      ) {
        Axios.post(Endpoints.Trailer.AssginVehicle, {
          token: localStorage.getItem("token"),
          trailer_id: this.AssginVehicle.trailer_id,
          vehicle_id: this.AssginVehicle.vehicle_id,
        }).then((Response) => {
          if (Response?.data?.success == true) {
            this.AssginVehicle.vehicle_id = 0;
            this.GetTrailerDetail();
            this.GetVehiclesList();
            $("#assign-vehicle .btn-danger").trigger("click");
            this.$swal
              .fire("Vehicle Assigned Successfully", "", "success")
              .then(() => {});
          } else {
            this.$swal
              .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
              .then(() => {});
          }
        });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Please Select Vehicle",
        });
      }
    },
    ViewDetailDocument (document){
      this.$refs.vehicle_document.ViewDetailDocument(document);
    },
    DeleteTrailer(trailer_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to delete this Trailer?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Trailer.Delete, {
              token: localStorage.getItem("token"),
              id: trailer_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.$router.push("/trailers-list");
                this.$swal
                  .fire("Trailer Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
  },
};
